import SvgIcon from '@mui/material/SvgIcon';
import { FC } from 'react';

import FlowrIcon from '@/assets/logos/icon_flowr.svg?react';
import { BrandIconProps } from '@/components/shared/logos/props';

const BrandIconFlowr: FC<BrandIconProps> = ({
  themeAware = true,
  ...other
}) => {
  return (
    <SvgIcon {...other}>
      <FlowrIcon />
    </SvgIcon>
  );
};

export default BrandIconFlowr;
